export enum CustomEventType {
    INPUT_CHANGE = 'input-change',
    TIME_INPUT_CHANGE = 'time-input-change',
    SEARCH_CHANGE = 'search-change',
    SELECTION_CHANGE = 'selection-change',
    COLOR_PICKED = 'color-picked',
    DELETE_TEAM = 'delete-team',
    TEAM_COLOR_CHANGE = 'team-color-change',
    CREATE_EVENT = 'create-event',
    DELETE_EVENT = 'delete-event',
    POINTS_RESET = 'points-reset',
    JEOPARDY_BROADCAST = 'jeopardy-broadcast',
    JEOPARDY_AWARD_POINT = 'jeopardy-award-point',
    JEOPARDY_CELL_CLICKED = 'jeopardy-cell-clicked',
    EVENT_UPDATED = 'event-updated',
    MILLIONAIRE_BROADCAST = 'millionaire-broadcast',
    FASTEST_TIME_CHANGE = 'fastest-time-change',
    SMALLEST_DIFFERENCE_CHANGE = 'smallest-difference-change',
    ROUND_POINT_CHANGE = 'round-point-change',
    USER_MESSAGE = 'user-message',
}

const REGISTERED_TYPES = new Set<string>(Object.values(CustomEventType));

export function installCustomEventValidator(): void {
    const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
    EventTarget.prototype.dispatchEvent = function (event: Event): boolean {
        if (event instanceof CustomEvent && !REGISTERED_TYPES.has(event.type) && !event.type.startsWith('__')) {
            throw new Error(
                `Unregistered custom event: "${event.type}". Add it to CustomEventType in CustomEventRegistry.ts.`
            );
        }
        return originalDispatchEvent.call(this, event);
    };
}
